import { call, put, takeLatest } from "redux-saga/effects";
import {
  getDefectsListApi,
  getDefectsDetailListApi,
  updateDefectsDetailListApi,
  uploadFilesDefectsDetailListApi,
  uploadFilesDefectsDetailDynamicApi,
} from "../requests/defectsRequests";
import { toast } from "react-toastify";
import { DefectsActions } from "../../action-types/defectsActionTypes";
import {
  setDefectsList,
  setDefectsDetailsList,
  isUpdateSuccessDefectsDetailsList,
  setDefectsPaginationList,
} from "../../actions/defectsAction";
import { setLoader, setLoaderSaveButton } from "../../actions/userActions";
import axios from "axios";

function* getDefectsHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getDefectsListApi, action.payload);
    if (data.status) {
      yield put(setDefectsList(data.data));
      yield put(setDefectsPaginationList(data.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* getDefectsDetailsHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getDefectsDetailListApi, action.payload?.id);
    if (data.status) {
      yield put(setDefectsDetailsList(data.data[0]));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function fileToBlob(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = () => {
      const blob = new Blob([reader.result], { type: file.type });
      resolve(blob);
    };

    reader.readAsArrayBuffer(file);
  });
}

function* updateDefectsDetailsHandler(action) {
  yield put(setLoaderSaveButton(true));
  // start loader here
  try {
    const successfulResponses = []; // Array to collect successful responses
    for (const row of action.payload.selectedIMG) {
      const payload1 = {
        contentType: row?.type,
      };
      const { data } = yield call(uploadFilesDefectsDetailListApi, payload1);
      if (data.status) {
        successfulResponses.push(data?.data?.key);
        // const binaryFileData = yield call(fileToBlob, row);
        const AWSUrl = yield call(uploadFilesDefectsDetailDynamicApi, {
          url: data?.data?.URL,
          file: row,
        });
      } else {
        // Handle unsuccessful response
      }
    }

    const payload = {
      defect_report_status: action?.payload?.defect_report_status,
      line_manager_attachment: [
        ...successfulResponses,
        ...action.payload?.AllReadyExiesIMG,
      ],
      line_manager_comment: action?.payload?.line_manager_comment,
      corrective_actions:
        action?.payload?.corrective_actions === ""
          ? null
          : action?.payload?.corrective_actions,
      followup_inspection:
        action?.payload?.followup_inspection === ""
          ? null
          : action?.payload?.followup_inspection,
      description: action?.payload?.description,
      cause: action?.payload?.cause,
      immediate_correction_qa_one: action?.payload?.immediate_correction_qa_one,
      immediate_correction_qa_two: action?.payload?.immediate_correction_qa_two,
      immediate_correction_qa_three:
        action?.payload?.immediate_correction_qa_three,
      id: action?.payload?.id,
    };
    // }
    const { data } = yield call(updateDefectsDetailListApi, payload);

    if (data.status) {
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      yield put(isUpdateSuccessDefectsDetailsList(true));
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    yield put(setLoaderSaveButton(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
  }
}

// accountHandler Sagas
export default function* defectsSaga() {
  yield takeLatest(DefectsActions.GET_DEFECTS_LIST, getDefectsHandler);
  yield takeLatest(
    DefectsActions.GET_DEFECTS_DETAILS_LIST,
    getDefectsDetailsHandler
  );
  yield takeLatest(
    DefectsActions.UPDATE_DEFECTS_DETAILS_LIST,
    updateDefectsDetailsHandler
  );
}
